<template>
  <SegmentList
    data-heap="lite-queries-list"
    :segments="segments"
    :loading="loading"
    :test-id="'lite-queries-list'"
    @item-click="selectSegment"
    ><template #static-item>
      <SegmentListItem
        :segment="allClientsFakeSegment"
        :loading="loading"
        @item-click="selectAllClients"
      >
      </SegmentListItem> </template
  ></SegmentList>
</template>

<script>
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia'
import { useSegmentsStore } from '@app/insights/store/segments'
import SegmentListItem from './segment-list-item.vue'
import SegmentList from './segment-list.vue'
import sharedSegment from '../mixins/shared-segment'

export default {
  components: {
    SegmentListItem,
    SegmentList,
  },

  mixins: [sharedSegment],

  computed: {
    ...mapPiniaState(useSegmentsStore, ['segments', 'segment']),
    allCompaniesLabel() {
      return I18n.t('segments.modal.all_companies')
    },
    loading() {
      return false
    },
  },

  methods: {
    ...mapPiniaActions(useSegmentsStore, ['loadSegment', 'unselectSegment']),

    selectSegment(segment) {
      if (!this.segment || this.segment.id !== segment.id) {
        this.loadSegment(segment)
      }
    },
  },
}
</script>
